import { useEffect, useState } from 'react';
import { ProductService, ContentService, ProductDiscountWithImage, ImageTransformation, TRANSFORMATIONS } from '@services';
import { useServiceRef } from './useServiceRef';
import { ALL_IMAGES_TRANSFORMATIONS, formatPrice } from '@utils';
import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';

const imageTransformation = new ImageTransformation();

export const useDiscounts = (): ProductDiscountWithImage[] => {
  const productServiceRef = useServiceRef(ProductService);
  const contentServiceRef = useServiceRef(ContentService);

  const [ discounts, setDiscounts ] = useState<ProductDiscountWithImage[]>([]);

  useEffect(() => {
    (async (): Promise<void> => {
      const discountsResponse = await productServiceRef.current.getActiveProductDiscounts();
      const discountKeys = discountsResponse.map(discount => discount.key);
      const discountBanners = await contentServiceRef.current.getProductDiscountBanners(discountKeys);
      const currentTenantKey = JSON.parse(Cookies.get(TENANT_STORAGE_KEY) || 'null')?.key as string | undefined;
      const normalizedTenantKey = currentTenantKey?.replace(/^tenant-/, '');

      const discounts = discountBanners?.map(discountBanner => {
        const discount = discountsResponse?.find(discountItem => discountBanner.discount_key === discountItem.key);

        if (!discount) {
          return null;
        }

        if (normalizedTenantKey && !discount.key.startsWith(normalizedTenantKey)) {
          return null;
        }

        const amount = discount.value.type === 'relative' ? `${discount.value.permyriad/100}%` : formatPrice({ value: discount.value.money[0].centAmount/100, currencyCode: discount.value.money[0].currencyCode });

        return (
          {
            ...discount,
            image: imageTransformation.transformById(
              discountBanner.cloudinary_discount_image?.[0]?.public_id,
              [ ...ALL_IMAGES_TRANSFORMATIONS,
                {
                  name: TRANSFORMATIONS.NAMED_TRASNFORMATION,
                  params: { name: 'discount-banner-background' }
                },
                {
                  name: TRANSFORMATIONS.TEXT_OVERLAY,
                  params: {
                    text: `${amount} discount`,
                    position: {
                      x: 40,
                      y: 58,
                      anchor: 'north_west'
                    },
                    textStyle: {
                      color: 'white',
                      size: 28,
                      bold: true
                    }
                  }
                },
                {
                  name: TRANSFORMATIONS.TEXT_OVERLAY,
                  params: {
                    text: discount.name,
                    position: {
                      x: 80,
                      y: 150,
                      anchor: 'north_west'
                    },
                    textStyle: {
                      size: 40
                    }
                  }
                } ],
              discountBanner.discount_image?.url
            )
          }
        );
      }) ?? [];

      setDiscounts(discounts.filter(Boolean));
    })();
  }, []);

  return discounts;
};
